module.exports = __webpack_public_path__ + "img/galleria5.7274d397.jpg";